









import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';

@Component({
  mixins: [InputMixin]
})
export default class TextInput extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: true}) private readonly autoSizeable: boolean;
  @Prop({default: true}) private readonly showWordLimit: boolean;
  @Prop({default: 'text'}) private readonly type: string;
  @Prop({default: ''}) private readonly suffixIcon: string;
  @Prop({default: 1}) private readonly minRows: number;
  @Prop({default: Infinity}) private readonly maxRows: number;
  @Prop({default: 'none'}) private readonly resize: string;

  get getResize() {
    return this.resize;
  }

  get inputType() {
    return this.type;
  }

  get getSuffixIcon() {
    return this.suffixIcon;
  }

  get isAutosizeable() {
    return this.autoSizeable ? {minRows: this.minRows, maxRows: this.maxRows} : false;
  }

  get supplyShowWordLimit() {
    return this.showWordLimit;
  }

  private onChangeInput(data: any) {
    if (this.isReadOnly) {
      return;
    }

    this.commitValue(data);
  }

  public onBlur() {
    if (this.isReadOnly) {
      return;
    }
    this.commitValue(this.value?.trim());

    this.$emit('blur');
  }

  public onFocus() {
    if (this.isReadOnly) {
      return;
    }

    this.$emit('focus');
  }

  public commitValue(data: any) {
    if (this.changeDetectable) {
      this.$store.commit('commitValue', {
        itemId: this.id,
        value: data,
        originValue: this.originValue
      });
    }
    this.$emit('input', data);
  }
}
